export default __webpack_public_path__ + "static/worktogether-3d20616d912d7cc026beff48883e7021.jpeg";